<template>
  <b-col class="m-auto">
    <slot name="logo"></slot>
    <h4 class="text-muted pb-4">{{ resources.page.login.newConfirm.title }}</h4>

    <b-form @submit.prevent="doConfirmRegister" ref="form">
      <CustomInput
        type="password"
        hasPasswordConfirm="true"
        :title="resources.general.input.passwordWarning"
        :label="resources.general.input.password"
        :labelWrong="resources.general.input.passwordWrong"
        :confirmTitle="resources.general.input.passwordConfirmWarning"
        :confirmLabel="resources.general.input.passwordConfirm"
        :confirmLabelWrong="resources.general.input.passwordConfirmWrong"
        v-on:update="updateConfirmRegisterForm('password', $event.value)"
      >
      </CustomInput>

      <b-row v-if="confirmRegister.message" align-h="center">
        <span id="exception-message" class="text-secondary">
          {{ confirmRegister.message }}
        </span>
      </b-row>

      <Recaptcha ref="recaptcha" @verify="recaptchaVerify">
        <b-button
          id="btn-confirm-register"
          type="submit"
          :disabled="submitInProgress"
          variant="quartenary"
          class="col-12 mb-3 mt-1"
        >
          <i
            class="mdi mdi-spin pr-2"
            v-bind:class="{ 'mdi-loading': submitInProgress }"
          ></i>
          {{ resources.page.login.newConfirm.signUp }}
        </b-button>
      </Recaptcha>
    </b-form>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomInput from '@/components/Shared/Form/CustomInput.vue'
import { getUser } from '@/service/user'
import ability from '@/helpers/ability'
import Recaptcha from '@/components/Shared/Recaptcha.vue'

export default {
  components: {
    CustomInput,
    Recaptcha,
  },

  data() {
    return {
      submitInProgress: false,
      recaptcha: '',
    }
  },

  computed: {
    email: function() {
      return (this.$route.query.email || '').replace(' ', '+')
    },

    ...mapGetters({
      confirmRegister: 'confirmRegister',
      resources: 'resources',
    }),
  },

  mounted: function() {
    this.$nextTick(() => {
      this.updateConfirmRegisterForm('email', this.email)
      this.updateConfirmRegisterForm('token', this.$route.params.token)
      this.$root.$emit('confirmation', getUser())
    })
  },

  methods: {
    recaptchaVerify(value) {
      this.updateConfirmRegisterForm('googleRecaptcha', value)
      this._doConfirmRegister()
    },

    updateConfirmRegisterForm(property, value) {
      this.$store.commit('updateConfirmRegisterForm', { property, value })
    },

    doConfirmRegister() {
      if (this.submitInProgress) return

      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity()
        this.resetRecaptcha()
        return false
      }

      this.$refs.recaptcha.execute()
    },

    _doConfirmRegister() {

      this.submitInProgress = true
      this.$store.commit('updateMessage', null)
      this.$store
        .dispatch('confirmRegister')
        .then(response => {
          this.$store.dispatch('user/saveUserData', response)

          this.$root.$emit('login', getUser())
          this.$root.$emit('trial', getUser())

          this.$ability.update(ability().rules)
          this.$router.push('/dashboard')
          this.submitInProgress = false
        })
        .catch(error => {
          this.$store.commit('updateMessage', error.response.data.message)
          this.submitInProgress = false
        })
    },

    resetRecaptcha() {
      this.$refs.recaptcha.resetRecaptcha()
    },
  },
}
</script>
